import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../plugins/custom_css/slider.css";

const SliderCard = ({ images = [], customClass = "" }) => {
  const shouldLoop = images.length > 2;
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      navigation={true}
      pagination={{ clickable: true }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={shouldLoop}
      modules={[Navigation, Pagination, Autoplay]}
      className={`mySwiper ${customClass}`}
    >
      {images.map((imgSrc, index) => (
        <SwiperSlide key={index}>
          <img src={imgSrc} alt={`Slide ${index + 1}`} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SliderCard;
